export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const CLEAR_USER_PROFILE = 'CLEAR_USER_PROFILE';
export const PATCH_USER_PROFILE = 'PATCH_USER_PROFILE';
export const SET_PUSH_TOKEN = 'SET_PUSH_TOKEN';
